import React from "react";
import styles from "../PricingWrapper.module.scss";
import AppliedPricing from "../../../../shared/appliedPricing/AppliedPricing";
import vehiclesStyles from "./NscVehicles.module.scss";
import Button from "@material-ui/core/Button";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import PricingDetails from "../pricingDetails/PricingDetails";
import { GPRS_ERROR_MESSAGE } from "../../../../common/Constants";
import { withTranslation } from "react-i18next";

const NscVehicles = (props) => {
  const navigateToOptions = (e) => {
    props.handleTabChange(e, 2);
  };

  return props.pricingData && props.pricingData.length > 0 ? (
    <div id="nscVehicleDetails">
      <PricingDetails {...props} isDealer={false} />

      {props.released &&
      !props.priceUpdatesAvailable &&
      !props.adminView &&
      !props.viewOnlyPricing ? (
        <div className={styles.appliedPricing}>
          <AppliedPricing />
        </div>
      ) : (
        <div className={vehiclesStyles.actionSection}>
          <HasPermissionTo
            permissions={props.user.permissions.rolePermissions}
            perform={["vehiclePricing:view"]}
            render={() => (
              <Button
                data-testid="applyPricesBtn"
                variant="contained"
                onClick={(event) => {
                  navigateToOptions(event);
                }}
                className={vehiclesStyles.applyBtn}
                component="button"
              >
                <span>Next</span>
              </Button>
            )}
          />
        </div>
      )}
    </div>
  ) : props.errorMessage === GPRS_ERROR_MESSAGE ? (
    <span className={styles.dataNotFound}>
      {" "}
      {props.t("Error.dataNotFoundFromSource")}
    </span>
  ) : (
    <span className={styles.dataNotFound}>
      {" "}
      {props.t("Error.dataNotFound")}
    </span>
  );
};

export default withTranslation("emp")(NscVehicles);
